import _property from 'lodash/property';

var dealerId = _property('dealerId');

var employeeDisplayNumber = _property('employeeDisplayNumber');

var employeeId = _property('employeeId');

var DEALER_EMPLOYEE_DETAILS_READER = {
  dealerId: dealerId,
  employeeDisplayNumber: employeeDisplayNumber,
  employeeId: employeeId
};
export default DEALER_EMPLOYEE_DETAILS_READER;